/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <header-test v-bind:gen="100" :pow="100" :theme="false"></header-test>

    <v-container
      fluid
      grid-list-sm
      v-if="this.isComponent('alert-dash') && this.getUserInfo('role') !== 'customer'"
    >
      <v-layout row wrap>
        <selection @change:date="updateDate" @change:device="updateDeviceChange"
        @change:severity="severityChange"></selection>
      </v-layout>
      <v-layout row>
        <data-table :header="tableHeaders" :data="tableData" :device="typeChange[0]"></data-table>
      </v-layout>
    </v-container>
    <no-device v-else :message="subscriptionMessage"></no-device>
  </div>
</template>

<script>

import { EventBus } from '@/services/event-bus'
import { mapGetters, mapMutations } from 'vuex'
import { mixin } from '@/util/mixin/index'
import moment from 'moment'

import Alert from '@/services/Alert.js'
import Selection from '@/components/Alert/Selection'
import DataTable from '@/components/Alert/DataTable'
const NoDevice = () => import('@/components/utility/NoDevice.vue')
const HeaderTest = () => import('@/components/dashboard-inverter/Header')

export default {
  components: {
    HeaderTest,
    NoDevice,
    Selection,
    DataTable
  },
  mixins: [mixin],
  data() {
    return {
      componentKey: 0,
      full_date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      sheet: true,
      tableData: [],
      tableHeaders: [],
      subscriptionMessage: 'This feature is not applicable for your plant',
      dialog: false,
      status: '',
      statusChange: ['new', 'acknowledge', 'resolved'],
      typeChange: ['inverter'],
      message: '',
      severity: 'critical',
      gridAuthorizedUser: ['satyam.rai@avisolar.com', 'harsha.k@avisolar.com']
    }
  },
  created() {
    EventBus.$on('downloadAlert', this.downloadAlertList)
    EventBus.$on('updateAlertStatus', this.updateAlertStatus)
    EventBus.$on('updateAlertStatusV2', this.updateAlertStatusV2)
    this.getEventLogs()
  },
  beforeDestroy() {
    EventBus.$off('downloadAlert', this.downloadAlertList)
    EventBus.$off('updateAlertStatus', this.updateAlertStatus)
    EventBus.$off('updateAlertStatusV2', this.updateAlertStatusV2)
  },
  methods: {
    ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT']),
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true)
      this.SET_SNACKBAR_CONTENT(payload)
    },
    updateDate(fullDate) {
      this.full_date = fullDate
    },
    updateDeviceChange(device) {
      this.typeChange.length = 0
      this.typeChange.push(device)
      this.getEventLogs()
    },
    updateAlertStatus(param) {
      Alert.updateStatus(param).then(response => {
        if (response.status === 200) {
          this.updateSnackbar({
            icon: 'success',
            message: 'Alert Updated Successfully'
          })
          this.getEventLogs()
        } else {
          this.updateSnackbar({
            icon: 'error',
            message: 'Alert Updated Failed'
          })
        }
      })
    },
    severityChange(severity) {
      console.log('SEVERITY CHANGE', severity)

      this.severity = severity
      this.getEventLogs()
    },
    updateAlertStatusV2(param) {
      Alert.updateStatusV2(param).then(response => {
        if (response.status === 200) {
          this.updateSnackbar({
            icon: 'success',
            message: 'Alert Updated Successfully'
          })
        } else {
          this.updateSnackbar({
            icon: 'error',
            message: 'Alert Updated Failed'
          })
        }
      })
    },
    getEventLogs() {
      if (this.isV2(this.getSelectedPlantId, 'alert')) {
        Alert.getAlertListV2(
          this.getSelectedPlantId,
          this.full_date[0],
          this.full_date[1],
          this.statusChange.join(),
          this.typeChange.join(),
          this.severity
        ).then(response => {
          if (response.status === 200) {
            this.tableData = response.data.message.data
            this.tableHeaders = response.data.message.header
          } else if (response.status === 403) {
            // this.$router.push("/login");
          }
        })
      } else {
        Alert.getAlertList(
          this.getSelectedPlantId,
          this.full_date[0],
          this.full_date[1],
          this.statusChange.join(),
          this.typeChange.join()
        ).then(response => {
          if (response.status === 200) {
            this.tableData = response.data.message.alert
            this.tableHeaders = response.data.message.header
          } else if (response.status === 403) {
            // this.$router.push("/login");
          }
        })
      }
    },
    downloadAlertList() {
      if (this.isV2(this.getSelectedPlantId, 'alert')) {
        try {
          Alert.downloadAlertListV2(
            this.getSelectedPlantId,
            this.getActivePlantInfo('plant_name'),
            this.full_date[0],
            this.full_date[1],
            this.statusChange.join(),
            this.typeChange.join(),
            'critical'
          )
        } catch (e) {
          console.log('Error donwloading alert list', e)
        }
      } else {
        try {
          Alert.downloadAlertList(
            this.getSelectedPlantId,
            this.getActivePlantInfo('plant_name'),
            this.full_date[0],
            this.full_date[1],
            this.statusChange.join(),
            this.typeChange.join()
          )
        } catch (e) {
          console.log('Error donwloading alert list', e)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isComponent',
      'getSelectedPlantId',
      'getUserInfo',
      'getActivePlantInfo',
      'isV2',
      'getUserInfo'
    ]),
    isGridAuthorized() {
      return this.gridAuthorizedUser.includes(this.getUserInfo('email'))
    }
  },
  watch: {
    typeChange() {
      this.getEventLogs()
    },
    full_date() {
      if (this.full_date === null) {
        this.full_date = [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ]
      } else if (
        this.dateValidate(this.full_date[0]) &&
        this.dateValidate(this.full_date[1])
      ) {
        this.start_date = this.full_date[0]
        this.end_date = this.full_date[1]
        if (this.start_date === this.end_date) {
          this.isMultipleDays = false
        } else {
          this.isMultipleDays = true
        }
        EventBus.$emit('dateChange', this.start_date, this.end_date)
      } else {
        this.updateSnackbar({
          icon: 'error',
          message: 'Please select a valid date'
        })
        this.full_date = [this.start_date, this.end_date]
      }
      this.getEventLogs()
    },
    getSelectedPlantId() {
      this.getEventLogs()
    }
  }
}
</script>
